import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { computed } from "mobx";
import { withStyles } from "@material-ui/core/styles";

import { TableCell, Typography, Grid, Hidden } from "@material-ui/core";
import { IValuesStore } from "Stores/Values/types";
import ApplicationEdit from "./ApplicationEdit/ApplicationEdit";
import EntityDelete from "@src/Components/Common/EntityDelete/EntityDelete";
import { IManagementStore } from "@src/Stores/Management/types";
import { STTableRow } from "@src/Components/Ui/STTableRow";
import { ApplicationLink } from "@src/Interfaces/Entity/ApplicationLink";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import styles from "./styles";
import { IAuthStore } from "@src/Stores/Auth/types";
import { STTableCellTypography } from "@src/Components/Ui/STTableCellTypography";

interface IProps {
  application: ApplicationLink;
  values?: IValuesStore;
  management?: IManagementStore;
  auth?: IAuthStore;
  classes?: any;
}

@inject("auth", "values", "management")
@observer
class ApplicationTableItem extends Component<IProps> {
  @computed get isActive() {
    return this.props.application.state === this.props.values.states.Active;
  }
  handleRemove = async () => {
    await this.props.management.removeApplicationLink(this.props.application.id);
  };

  @computed get applicationUrl() {
    const { application, auth } = this.props;
    if (application.isSameUrlForAllLocations) {
      return application.commonApplicationUrl;
    }
    const currentApplication = application.applicationUrls.find(
      application => application.locationId === auth.user.location.id
    );
    return currentApplication ? currentApplication.applicationUrl : "";
  }

  render() {
    const { application, classes } = this.props;
    return (
      <STTableRow hover isActive={this.isActive}>
        <TableCell component="th" scope="row" size="small">
          <STTableCellTypography>{application.title}</STTableCellTypography>
        </TableCell>
        <TableCell size="small">
          <STTableCellTypography>{application.description}</STTableCellTypography>
        </TableCell>
        <TableCell size="small">
          <STTableCellTypography>{this.applicationUrl}</STTableCellTypography>
        </TableCell>
        <TableCell size="small">
          <div className={classes.iconsRoot}>
            {application.mobile ? (
              <CheckIcon className={classes.checkIcon} />
            ) : (
              <CloseIcon className={classes.closeIcon} />
            )}
          </div>
        </TableCell>
        <TableCell size="small">
          <div className={classes.iconsRoot}>
            {application.desktop ? (
              <CheckIcon className={classes.checkIcon} />
            ) : (
              <CloseIcon className={classes.closeIcon} />
            )}
          </div>
        </TableCell>
        <TableCell align="right" size="small">
          <Grid container wrap="nowrap" justify="flex-end">
            {this.props.auth.user.location.primary && (
              <>
                <ApplicationEdit application={application} />
                <Hidden xsUp={application.baseApplication}>
                  <EntityDelete onSubmit={this.handleRemove} />
                </Hidden>
              </>
            )}
          </Grid>
        </TableCell>
      </STTableRow>
    );
  }
}

export default withStyles(styles)(ApplicationTableItem);
